import { Badge } from "react-bootstrap";
import { TRANSACTION_STATUS } from "../../constants/transaction";

export const renderAction = (action) => {
  if (action === "TOPUP") {
    return (
      <Badge bg="success">
        <span style={{ fontSize: "12px" }}>ເຕີ່ມເງິນ</span>
      </Badge>
    );
  } else {
    return (
      <Badge bg="danger">
        <span style={{ fontSize: "12px" }}>ຖອນເງິນ</span>
      </Badge>
    );
  }
};

export const renderStatus = (status) => {
  switch (status) {
    case TRANSACTION_STATUS.SUCCESS:
      return (
        <Badge bg="success">
          <span style={{ fontSize: "12px" }}>ສຳເລັດ</span>
        </Badge>
      );
    case TRANSACTION_STATUS.PENDING:
      return (
        <Badge bg="warning">
          <span style={{ fontSize: "12px" }}>ລໍຖ້າຢື່ນຢັນ</span>
        </Badge>
      );
    case TRANSACTION_STATUS.CANCEL:
      return (
        <Badge bg="danger">
          <span style={{ fontSize: "12px" }}>ຍົກເລີກແລ້ວ</span>
        </Badge>
      );
    default:
      break;
  }
};
